/*
* @描述:
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2022-11-23 18:09:48
*/
<template>
    <div>
        <el-form size="small"
                 ref="pointForm"
                 label-position="right"
                 label-width="auto"
                 :model="pointForm"
                 :rules="pointFormRules">
            <el-form-item label="名称" prop="title">
                <el-input v-model="pointForm.title" placeholder="请输入名称"></el-input>
            </el-form-item>
            <el-form-item label="链接" prop="route">
                <el-input v-model="pointForm.route" placeholder="输入模块/控制器/方法即可 例如 Admin/Nav/index"></el-input>
            </el-form-item>
            <el-form-item label="组件类型" prop="type">
                <el-radio-group v-model="pointForm.type">
                    <el-radio :label="1">基础组件</el-radio>
                    <el-radio :label="2">快捷组件</el-radio>
                    <el-radio :label="3">待办组件</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="角色权限是否展示" prop="role_show">
                <el-switch v-model="pointForm.role_show"
                           active-text="是"
                           inactive-text="否"
                           :active-value="1"
                           :inactive-value="0">
                </el-switch>
            </el-form-item>
            <el-form-item label="是否有范围数据权限" prop="role_range">
                <el-switch v-model="pointForm.role_range"
                           active-text="是"
                           inactive-text="否"
                           :active-value="1"
                           :inactive-value="0">
                </el-switch>
            </el-form-item>
            <el-form-item label="是否为公共节点" prop="is_public">
                <el-switch v-model="pointForm.is_public"
                           active-text="是"
                           inactive-text="否"
                           :active-value="1"
                           :inactive-value="0">
                </el-switch>
            </el-form-item>
        </el-form>
        <div class="btn">
            <el-button size="small" @click="handleClickCancel">取消</el-button>
            <el-button size="small" type="primary" @click="handleClickConfirm">确定</el-button>
        </div>
    </div>
</template>
<script>
    import {AddMenu, EditMenu, MenuDetail,} from '@/api'

    export default {
        name: 'pointTpl',
        props: {
            pointTplVisible: {
                type: Boolean,
                default: false,
            },
            pointId: {
                type: Number,
                default: 0,
            },
            pointPid: {
                type: Number,
                default: 0,
            },
            menu_pid_path: {
                type: String,
                default: '',
            },
        },
        data() {
            return {
                pointForm: {
                    title: "",
                    route: "",
                    pid: 0,
                    id: '',
                    type: 1,
                    role_show: 1,
                    role_range: 1,
                    is_public: 1,
                    menuflag: 1,
                    single: 0,
                    pid_path: ''
                },
                pointFormRules: {
                    title: [{required: true, message: '请输入名称'}],
                    route: [{required: true, message: '请输入链接'}],
                    type: [{required: true, message: '请选择基础组件'}],
                }
            }
        },
        created() {
        },
        mounted() {
            if (this.pointPid !== 0) {
                this.pointForm.pid = this.pointPid
            }
            if (this.pointId > 0) {
                this.getMenuDetail()
            }
        },
        methods: {
            //获取菜单详情
            getMenuDetail() {
                MenuDetail({
                    treenode_id: this.pointId
                }).then(res => {
                    if (res.code === 200) {
                        this.pointForm.title = res.data.title
                        this.pointForm.route = res.data.route
                        this.pointForm.role_range = res.data.role_range
                        this.pointForm.role_show = res.data.role_show
                        this.pointForm.is_public = res.data.is_public
                        this.pointForm.menuflag = res.data.menuflag
                        this.pointForm.single = res.data.single
                        this.pointForm.pid_path = res.data.pid_path
                        this.pointForm.type = res.data.type ? res.data.type : 1
                    }
                    this.loading = false
                })
            },

            //取消事件
            handleClickCancel() {
                //重置表格
                this.$refs.pointForm.resetFields()
                //关闭对话框
                this.$emit('update:pointTplVisible', false)
            },

            //确定事件
            handleClickConfirm() {
                this.$refs.pointForm.validate(valid => {
                    if (valid) {
                        // 验证通过调用新增菜单接口
                        if (this.pointId > 0) {
                            this.pointForm.treenode_id = this.pointId
                            EditMenu(this.pointForm).then(res => {
                                if (res.code === 200) {
                                    this.$message.success('编辑成功')
                                    //调用取消事件
                                    this.handleClickCancel()
                                    //父页面刷新列表
                                    this.$emit('success')
                                }
                            })
                        } else {
                            this.pointForm.pid_path = this.menu_pid_path
                            AddMenu(this.pointForm).then(res => {
                                if (res.code === 200) {
                                    this.$message.success('新增成功')
                                    //调用取消事件
                                    this.handleClickCancel()
                                    //父页面刷新列表
                                    this.$emit('success')
                                }
                            })
                        }

                    } else {
                        return false
                    }
                })
            },
        },

    }
</script>
<style lang="scss" scoped>
  .btn {
    text-align: right
  }
</style>
